import transEN from "locale/en.json"
import transAR from "locale/ar.json"

export function page_SEO(
    page_title?: string,
    page_description?: string,
    o_gtype?: string,
    url?: string,
    site_name?: string
) {
    // const locale = window?.location.pathname.split("/")[1]
    type locale = "en" | "ar"
    type Resource = {
        [key in locale]: {
            translation: {
                [key: string]: string
            }
        }
    }

    const resources = {
        ar: {
            translation: transAR,
        },
        en: {
            translation: transEN,
        },
    }
    const isAr = "ar-SA"

    // check if the current language is arabic
    // if it is, return the arabic translation
    // if not, return the english translation
    const lang: string = isAr ? "ar" : "en"
    const t = (key: string) => {
        return resources[lang]?.translation[key]
    }
    const description = page_description ? page_description : t("ABOUT_US_DESC")

    // get the current language from the url path
    const seo_items = {
        app_title: t("SITE_NAME"),
        title:
            (page_title ? page_title + " | " : "") +
            t("SITE_LONG_TITLE") +
            " | " +
            t("SITE_NAME"),
        description: description,
        openGraph: {
            type: o_gtype,
            locale: isAr ? "ar_SA" : "en_US",
            url: url || "pass-tickets.com",
            site_name: site_name || t("SITE_NAME"),
        },
    }

    return seo_items
}
